<template>
  <v-app>
    <v-img v-if="hero.hide === false" :src="require('./assets/flag.jpg')" class="flag"/>
    <v-app-bar
      v-if="hero.hide === false"
      color="transparent"
      class="elevation-0"
      height="86"
    >
      <div class="vxp-banner-container">
        <v-row class="fill-height" :style="cssVars" :justify="mobile ? 'end' : 'start'">
          <v-app-bar-nav-icon v-if="mobile" @click="drawer = !drawer" absolute left top class="mr-1"></v-app-bar-nav-icon>
          <p v-if="$vuetify.breakpoint.smAndUp" :class="!mobile ? 'top-left-title' : 'top-right-title'">Olli Kotro</p>
          <v-spacer v-if="!mobile"/>
          <div v-if="!mobile" class="pr-6">
            <v-btn text @click="goTo('#esittely')" :color="color.primary.hex">Esittely</v-btn>
            <v-btn text @click="goTo('#blogi')" :color="color.primary.hex">Blogi</v-btn>
            <v-btn text @click="goTo('#twitter')" :color="color.primary.hex">Twitter</v-btn>
            <v-btn text @click="goTo('#facebook')" :color="color.primary.hex">Facebook</v-btn>
            <v-btn text @click="goTo('#yhteystiedot')" :color="color.primary.hex">Yhteystiedot</v-btn>
            <v-btn v-if="hero.vaaliteemat" text @click="goTo('#vaaliteemat')" :color="color.primary.hex">{{ hero.vaaliteematTeksti ? hero.vaaliteematTeksti : 'Vaaliteemat' }}</v-btn>
          </div>
        </v-row>
      </div>
    </v-app-bar>
    <v-sheet :style="cssVars">
      <div v-if="hero.hide === false" class="vxp-banner-container kotro-image" style="position:relative; overflow:hidden;">
        <v-row style="position:relative;">
          <v-col cols="5" class="pl-10 text-right pr-0" :class="mobile ? 'pt-10 pb-8' : 'pb-14'">
            <v-row align="center" justify="center" style="height: 100%;">
              <div style="position:relative;" class="number-circle-parent">
                <v-btn
                  v-if="loggedIn && !editing.hero"
                  :color="color.primary.hex"
                  fab
                  dark
                  x-small
                  absolute
                  top
                  right
                  style="margin-top: -12px;"
                  @click="editing.hero = true"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn
                  v-if="loggedIn && !editing.hero"
                  :color="color.primary.hex"
                  fab
                  dark
                  x-small
                  absolute
                  top
                  right
                  style="margin-top: -12px;margin-right: -38px;"
                  @click="showHeroSelectionDialog()"
                >
                  <v-icon>mdi-image</v-icon>
                </v-btn>
                <p class="vxp-hero-text">
                  Olli Kotro
                </p>
                <!-- Desktop esittelyteksti-->
                <template v-if="$vuetify.breakpoint.smAndUp">
                  <v-textarea outlined label="Esittelyteksti" class="mt-3" rows="6" v-if="editing.hero && loggedIn" v-model="hero.content"/>
                  <p v-else class="vxp-hero-subtitle" v-html="c(hero.content)"/>
                  <v-btn v-if="hero.vaaliteemat" rounded small class="mb-4" dark outlined :color="color.primary.hex" @click="goTo('#vaaliteemat')">{{ hero.vaaliteematTeksti ? hero.vaaliteematTeksti : 'Vaaliteemat' }}<v-icon>mdi-arrow-right</v-icon></v-btn>
                </template>
                <v-row :justify="mobile ? 'center' : 'end'" align="center" class="pb-2">
                  <div v-for="(circle, idx) in hero.circles" :key="idx" class="number-circle">
                    <p v-if="!editing.hero" class="mb-0" :class="mobile ? 'mt-4' : 'mt-7'">{{ circle.number }}<br><span class="caption">{{ circle.caption }}</span></p>
                    <template v-else>
                      <v-col class="pt-0 circle-edit" style="position:relative;">
                        <v-btn
                          v-if="loggedIn && editing.hero"
                          :color="color.primary.hex"
                          fab
                          dark
                          x-small
                          absolute
                          top
                          right
                          style="margin-top: -14px; margin-right: -8px;"
                          @click="deleteCircle(idx)"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                        <v-text-field class="display-1" :class="mobile ? 'px-2' : 'px-10'" hide-details dark v-model="circle.number"/>
                        <v-text-field dark class="caption" :class="mobile ? 'px-2' : 'px-10'" hide-details v-model="circle.caption"/>
                      </v-col>
                    </template>
                  </div>
                  <v-btn v-if="editing.hero && loggedIn" icon :color="color.primary.hex" @click="addCircle({ number: '', caption: '' })">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </v-row>
                <v-btn v-if="!mobile && editing.hero && loggedIn" rounded dark depressed :color="color.primary.hex" class="mb-4 ml-4 mt-4" @click="editing.hero = false;confirmation();">Ok</v-btn>
              </div>
            </v-row>
          </v-col>
          <v-col v-if="$vuetify.breakpoint.smAndUp" cols="7" class="pb-0 pt-0" style="display:flex;">
            <v-img :src="hero.heroImage">
            </v-img>
          </v-col>
          <v-img v-else style="" class="mobile-image-position" eager :src="hero.heroImage">
          </v-img>
        </v-row>
        <template v-if="!$vuetify.breakpoint.smAndUp">
          <v-sheet color="white" style="position:relative; z-index: 1;" class="pa-8 elevation-10">
            <v-textarea outlined label="Esittelyteksti" class="mt-3" hide-details rows="6" v-if="editing.hero && loggedIn" v-model="hero.content"/>
            <div v-else class="vxp-hero-subtitle" v-html="c(hero.content)"/>
            <v-row justify="end">
              <v-btn v-if="hero.vaaliteemat" rounded small class="mt-4" dark outlined :color="color.primary.hex" @click="goTo('#vaaliteemat')">{{ hero.vaaliteematTeksti ? hero.vaaliteematTeksti : 'Vaaliteemat' }}<v-icon>mdi-arrow-right</v-icon></v-btn>
            </v-row>
            <v-btn v-if="mobile && editing.hero && loggedIn" rounded dark depressed :color="color.primary.hex" class="mt-2" @click="editing.hero = false;confirmation();">Ok</v-btn>
          </v-sheet>
        </template>
      </div>
      <v-sheet v-if="hero.hide === false" class="sheet-background">
        <div class="vxp-banner-container text-center py-8">
          <v-row :class="mobile ? 'mx-0' : ''">
            <v-col v-if="page !== 'vaaliteemat'">
              <v-card id="esittely" outlined class="ml-md-6 ml-2 mr-2 mb-10 text-left">
                <v-btn
                  v-if="loggedIn && !editing.esittely"
                  class="mt-8"
                  :color="color.primary.hex"
                  fab
                  dark
                  x-small
                  absolute
                  top
                  right
                  @click="editing.esittely = true"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <vue-simplemde v-if="editing.esittely && loggedIn" v-model="esittely.content" ref="markdownEditor" :configs="configs"/>
                <v-card-text v-else class="py-md-12 py-10 px-md-16 px-8 vxp-content" v-html="c(esittely.content)"/>
                <v-btn v-if="editing.esittely && loggedIn" rounded dark depressed :color="color.primary.hex" class="mb-4 ml-4 mt-4" @click="editing.esittely = false;confirmation();">Ok</v-btn>
                <v-row justify="end" style="margin-top: -34px;">
                  <v-btn v-if="hero.vaaliteemat" rounded dark depressed :color="color.primary.hex" class="mx-14 mb-6" @click="goTo('#vaaliteemat')">{{ hero.vaaliteematTeksti ? hero.vaaliteematTeksti : 'Vaaliteemat' }}<v-icon>mdi-arrow-right</v-icon></v-btn>
                </v-row>
             </v-card>
              <v-card id="blogi" outlined class="ml-md-6 ml-2 mr-2 mb-10">
                <v-card-text class="py-md-12 py-10 px-md-16 px-8 text-left vxp-content">
                  <v-row>
                    <v-col cols="12" md="9" class="pt-0" :class="mobile ? 'pr-3' : 'pr-12'">
                      <template v-if="news[newsItemIndex]">
                        <h2 class="mb-1">{{ news[newsItemIndex].title }}</h2>
                        <p>{{ news[newsItemIndex].date }}</p>
                        <v-img v-if="news[newsItemIndex].image" :src="news[newsItemIndex].image" class="mb-8" max-width="800">
                          <v-btn
                            v-if="loggedIn"
                            class="mt-8 mr-12"
                            :color="color.primary.hex"
                            fab
                            dark
                            x-small
                            absolute
                            top
                            right
                            @click="news[newsItemIndex].image = ''"
                          >
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                          <v-btn
                            v-if="loggedIn"
                            class="mt-8"
                            :color="color.primary.hex"
                            fab
                            dark
                            x-small
                            absolute
                            top
                            right
                            @click="selectBlogImage()"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                        </v-img>
                        <v-btn
                          v-else-if="loggedIn"
                          class="my-8"
                          :color="color.primary.hex"
                          dark
                          @click="selectBlogImage()"
                        >
                          <v-icon>mdi-image</v-icon>
                          Valitse kuva
                        </v-btn>
                        <div class="blog-content" v-html="c(news[newsItemIndex].description)"/>
                        <v-row v-if="loggedIn" align="center">
                          <v-btn :color="color.primary.hex" class="mx-1" dark rounded depressed @click="editBlog(news[newsItemIndex])">Muokkaa</v-btn>
                          <v-btn
                            :color="color.primary.hex"
                            fab
                            depressed
                            class="mx-1"
                            dark
                            x-small
                            @click="deleteNews = true"
                          >
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                          <v-btn
                            :color="color.primary.hex"
                            fab
                            depressed
                            class="mx-1"
                            dark
                            x-small
                            @click="moveBlogDown(news[newsItemIndex])"
                          >
                            <v-icon>mdi-chevron-up</v-icon>
                          </v-btn>
                          <v-btn
                            :color="color.primary.hex"
                            fab
                            depressed
                            class="mx-1"
                            dark
                            x-small
                            @click="moveBlogUp(news[newsItemIndex])"
                          >
                            <v-icon>mdi-chevron-down</v-icon>
                          </v-btn>
                        </v-row>
                      </template>
                    </v-col>
                    <v-col cols="12" md="3" class="pr-0 pl-6 blog-list">
                      <h3 class="mt-4 mb-2" :class="mobile ? 'ml-0' : 'ml-1'">Blogi</h3>
                      <v-list>
                        <v-list-item two-line v-for="(newsItem, idx) in showingNews" :key="idx" class="pr-0" :class="mobile ? 'pl-0': ''" @click="selectBlogItem(idx)">
                          <v-list-item-content>
                            <v-list-item-title class="blog-list-title">{{ newsItem.title }}</v-list-item-title>
                            <v-list-item-subtitle>{{ newsItem.date }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-if="loggedIn" @click="editBlog({ title: '', date: newsItemDate, description: '', image: '' } , true)">
                          <p class="blue--text mb-0 body-1">
                            Uusi kirjoitus
                          </p>
                          <v-spacer/>
                          <v-icon :color="color.primary.hex" class="ml-1">mdi-plus-circle</v-icon>
                        </v-list-item>
                      </v-list>
                      <v-row justify="center">
                        <v-btn
                          v-if="showingNews.length < news.length"
                          :color="color.primary.hex || 'grey lighten-2'"
                          rounded
                          dark
                          x-large
                          class="mt-4 mb-10"
                          @click="offset += 10"
                        >
                          Lisää
                          <v-icon>mdi-arrow-down</v-icon>
                        </v-btn>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
              <v-card id="yhteystiedot" outlined class="ml-md-6 mr-md-3 mx-2 mb-4 text-left">
                <v-btn
                  v-if="loggedIn && !editing.yhteystiedot"
                  class="mt-8"
                  :color="color.primary.hex"
                  fab
                  dark
                  x-small
                  absolute
                  top
                  right
                  @click="editing.yhteystiedot = true"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <vue-simplemde v-if="editing.yhteystiedot && loggedIn" v-model="yhteystiedot.content" ref="markdownEditorYhteystiedot" :configs="configs"/>
                <v-card-text v-else class="py-md-12 py-10 px-md-16 px-8 vxp-content" v-html="c(yhteystiedot.content)"/>
                <v-btn v-if="editing.yhteystiedot && loggedIn" rounded dark depressed :color="color.primary.hex" class="mb-4 ml-4 mt-4" @click="editing.yhteystiedot = false;confirmation();">Ok</v-btn>
              </v-card>
            </v-col>
            <v-col v-else>
              <v-card id="vaaliteemat" outlined class="ml-md-6 mr-md-3 mx-2 mb-4 text-left">
                <v-btn
                  v-if="loggedIn && !editing.vaaliteemat"
                  class="mt-8"
                  :color="color.primary.hex"
                  fab
                  dark
                  x-small
                  absolute
                  top
                  right
                  @click="editing.vaaliteemat = true"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <vue-simplemde v-if="editing.vaaliteemat && loggedIn" v-model="vaaliteemat.content" ref="markdownEditorYhteystiedot" :configs="configs"/>
                <v-card-text v-else class="py-md-12 py-10 px-md-16 px-8 vxp-content" v-html="c(vaaliteemat.content)"/>
                <v-btn v-if="editing.vaaliteemat && loggedIn" rounded dark depressed :color="color.primary.hex" class="mb-4 ml-4 mt-4" @click="editing.vaaliteemat = false;confirmation();">Ok</v-btn>
              </v-card>
            </v-col>
            <v-col cols="12" md="4" lg="3">
              <v-card id="twitter" outlined class="ml-md-6 ml-md-0 mr-md-6 mx-2">
                <v-card-title class="py-4">
                  <v-icon
                    large
                    left
                  >
                    mdi-twitter
                  </v-icon>
                  <span class="title font-weight-light">Twitter</span>
                </v-card-title>
                <v-card-text>
                  <a class="twitter-timeline" data-lang="fi" data-height="800" data-chrome="noheader nofooter noborders" href="https://twitter.com/OlliKotro?ref_src=twsrc%5Etfw">Tweets by OlliKotro</a>
                </v-card-text>
              </v-card>
              <v-card id="facebook" class="mt-8 pb-4 ml-md-6 ml-md-0 mr-md-6 mx-2" outlined>
                <v-card-title class="py-4">
                  <v-icon
                    large
                    left
                  >
                    mdi-facebook
                  </v-icon>
                  <span class="title font-weight-light">Facebook</span>
                </v-card-title>
                <div class="fb-page" data-href="https://www.facebook.com/OlliKotroPolitiikkasivu" data-tabs="timeline" data-width="340" data-height="800" data-small-header="false" data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="true"><blockquote cite="https://www.facebook.com/OlliKotroPolitiikkasivu" class="fb-xfbml-parse-ignore"><a href="https://www.facebook.com/OlliKotroPolitiikkasivu">Olli Kotro Politiikkasivusto</a></blockquote></div>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </v-sheet>

      <v-dialog v-model="blogEdit" fullscreen>
        <v-card>
          <v-container>
            <v-card-title>Blogikirjoitus</v-card-title>
            <v-card-text>
              <v-text-field
                v-model="editedBlog.title"
                label="Otsikko"
                outlined
              />
              <v-text-field
                v-model="editedBlog.date"
                label="Päivämäärä"
                outlined
              />
              <vue-simplemde v-model="editedBlog.description" ref="markdownEditor" :configs="configs"/>
            </v-card-text>
            <v-card-actions>
              <v-spacer/>
              <v-btn
                depressed
                class="mr-1 mb-1"
                @click="cancelBlogEdit()"
              >
                Peruuta
              </v-btn>
              <v-btn
                depressed
                class="mr-1 mb-1"
                :color="color.primary.hex"
                dark
                @click="updateBlog()"
              >
                Ok
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="uploadImagesDialog"
        width="500"
      >
        <upload-image/>
      </v-dialog>

      <v-dialog
        v-model="showHeroSelection"
        width="800"
      >
        <v-card>
          <v-card-title>
            Valitse pääkuva
          </v-card-title>
          <v-card-text class="grey lighten-2 pa-4">
            <v-row>
              <v-col
                v-for="(item, index) in selectableImages"
                :key="index"
                cols="12"
                md="4"
              >
                <v-img
                  :src="item"
                  aspect-ratio="1"
                  @click="hero.heroImage = item; showHeroSelection = false;"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="selectBlogImageModal"
        width="800"
      >
        <v-card>
          <v-card-title>
            Valitse kirjoitukselle kuva
          </v-card-title>
          <v-card-text class="grey lighten-2 pa-4">
            <v-row>
              <v-col
                v-for="(item, index) in selectableImages"
                :key="index"
                cols="4"
                md="2"
              >
                <v-img
                  :src="item"
                  aspect-ratio="1"
                  @click="news[newsItemIndex].image = item; selectBlogImageModal = false;"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="loginDialog"
        width="500"
      >
        <v-btn @click="openLogin()">Kirjaudu</v-btn>
      </v-dialog>

      <v-dialog
        v-model="settingsDialog"
        width="500"
      >
        <v-card>
          <v-card-title>Asetukset</v-card-title>
          <v-card-text>
            <legend>Tehosteväri</legend>
            <v-color-picker
              v-if="color && color.primary"
              v-model="color.primary.hex"
              mode="hexa"
              hide-mode-switch
            />
            <legend>Taustaväri</legend>
            <v-color-picker
              v-if="color && color.tertiary"
              v-model="color.tertiary.hex"
              mode="hexa"
              hide-mode-switch
            />
          </v-card-text>
            <v-text-field
              v-model="hero.metaDescription"
              color="pink"
              class="mb-4 mx-4"
              label="Meta-selite hakukoneille"
              hide-details
              outlined
            />
            <v-text-field
              v-model="hero.footerText"
              color="pink"
              class="mb-4 mx-4"
              label="Footer-teksti"
              hide-details
              outlined
            />
            <v-text-field
              v-model="hero.instagramLink"
              color="pink"
              class="mb-4 mx-4"
              label="Twitter-linkki"
              hide-details
              outlined
            />
            <v-text-field
              v-model="hero.facebookLink"
              color="pink"
              class="mb-4 mx-4"
              label="Facebook-linkki"
              hide-details
              outlined
            />
            <v-text-field
              v-model="hero.vaaliteematTeksti"
              color="pink"
              class="mb-4 mx-4"
              label="Vaaliteemat -napin teksti"
              hide-details
              outlined
            />
            <v-checkbox
              v-model="hero.vaaliteemat"
              class="mb-4 mx-4"
              color="pink"
              label="Näytä vaaliteemat"
            />
            <v-checkbox
              v-model="hero.hide"
              class="mb-4 mx-4"
              color="pink"
              label="Piilota sivusto"
            />

      <v-dialog v-if="currentGalleryItem && currentGalleryItem.gallery" v-model="galleryDialog" fullscreen>
        <v-card style="background: rgba(0,0,0,0.8);">
          <v-carousel
            :height="mobileHero ? '100vh' : '100vh'"
            v-model="carouselItem"
            hide-delimiters
            :show-arrows="currentGalleryItem.gallery.length > 1"
          >
            <v-carousel-item
              v-for="(img, index) in currentGalleryItem.gallery"
              :key="index"
            >
              <v-row no-gutters align="center" justify="center" class="fill-height">
                <div style="width:100%;height:100%;">
                  <v-img
                    eager
                    contain
                    height="90%"
                    :src="img.image"
                  />
                  <v-row justify="center">
                    <v-text-field
                      v-if="loggedIn"
                      v-model="img.caption"
                      outlined
                      hide-details
                      dark
                      dense
                      class="my-2 mx-4"
                      label="Selite"
                      style="max-width:800px;"
                    />
                    <p v-else class="white--text text-center mx-7 mt-2">
                      {{ img.caption }}
                    </p>
                  </v-row>
                </div>
              </v-row>
            </v-carousel-item>
          </v-carousel>
          <v-btn
            class="mt-8"
            :color="color.primary.hex"
            fab
            dark
            small
            absolute
            top
            right
            @click="galleryDialog = false;"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card>
      </v-dialog>
          <v-card-actions>
            <v-spacer/>
            <v-btn
              @click="settingsDialog = false;"
              dark depressed
              :color="color.primary.hex"
            >
              Ok
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="newPageDialog"
        width="500"
      >
        <v-card>
          <v-card-title>Uusi sivu</v-card-title>
          <v-card-text>
            <v-text-field
              v-model="newPageTitle"
              color="pink"
              class="mb-4"
              label="Sivun otsikko"
              hide-details
              outlined
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn @click="newPageDialog = false;" depressed>Peruuta</v-btn>
            <v-btn
              :disabled="!newPageTitle"
              dark
              :color="color.primary.hex"
              @click="newPage()" depressed
            >
              Ok
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="deleteNews"
        width="500"
      >
        <v-card>
          <v-card-title>Poista blogikirjoitus</v-card-title>
          <v-card-text>
            Oletko varma että haluat poistaa kirjoituksen?
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn @click="deleteNews = false;" depressed>Peruuta</v-btn>
            <v-btn @click="deleteNewsItem()" :color="color.primary.hex" dark depressed>Ok</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="saveDialog"
        width="500"
      >
        <v-card>
          <v-card-title>Tallennetaanko muutokset?</v-card-title>
          <v-card-text>
            Tallennetaanko muutokset palvelimelle? Voit tehdä tämän myös myöhemmin.
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn @click="saveDialog = false;" depressed>Ei</v-btn>
            <v-btn
              @click="save();saveDialog = false;"
              :color="color.primary.hex"
              dark
              depressed
            >
              Kyllä
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-sheet>
    <v-spacer/>
    <v-footer v-if="hero.hide === false" padless :class="loggedIn ? 'pb-12' : ''">
      <v-card
        flat
        tile
        width="100%"
        class="pt-4 pb-10 text-center grey lighten-2"
      >
        <v-card-text class="pb-0">
          <v-btn
            v-if="hero.instagramLink"
            class="mx-4"
            :href="hero.instagramLink"
            icon
          >
            <v-icon size="28px">
              mdi-twitter
            </v-icon>
          </v-btn>
          <v-btn
            v-if="hero.facebookLink"
            class="mx-4"
            icon
            :href="hero.facebookLink"
          >
            <v-icon size="28px">
              mdi-facebook
            </v-icon>
          </v-btn>
        </v-card-text>
        <v-card-text>
          {{ hero.footerText }}
        </v-card-text>
        <v-card-text class="pt-0">
          {{ new Date().getFullYear() }} — <strong>{{ siteTitle }}</strong>
        </v-card-text>
      </v-card>
    </v-footer>

    <v-navigation-drawer
      v-model="drawer"
      absolute
      temporary
      :style="cssVars"
    >
      <v-list
        class="px-0 pt-0"
        nav
      >
        <v-list-item
          class="px-4 py-2 mb-0"
          @click="goTo('#esittely');drawer = false;"
          link
        >
          <v-list-item-content>
            <v-list-item-title>Esittely</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          class="px-4 py-2 mb-0"
          @click="goTo('#blogi');drawer = false;"
          link
        >
          <v-list-item-content>
            <v-list-item-title>Blogi</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          class="px-4 py-2 mb-0"
          @click="goTo('#twitter');drawer = false;"
          link
        >
          <v-list-item-content>
            <v-list-item-title>Twitter</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          class="px-4 py-2 mb-0"
          @click="goTo('#facebook');drawer = false;"
          link
        >
          <v-list-item-content>
            <v-list-item-title>Facebook</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          class="px-4 py-2 mb-0"
          @click="goTo('#yhteystiedot');drawer = false;"
          link
        >
          <v-list-item-content>
            <v-list-item-title>Yhteystiedot</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="hero.vaaliteemat"
          class="px-4 py-2 mb-0"
          @click="goTo('#vaaliteemat');drawer = false;"
          link
        >
          <v-list-item-content>
            <v-list-item-title>{{ hero.vaaliteematTeksti ? hero.vaaliteematTeksti : 'Vaaliteemat' }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-bottom-navigation v-if="showLogout" fixed>
      <v-btn v-if="loggedIn" value="recent" @click="save()" class="pl-2 pr-2">
        <span>Julkaise</span>

        <v-icon color="pink">mdi-cloud-upload</v-icon>
      </v-btn>

      <v-btn v-if="loggedIn"  value="recent" @click="settingsDialog = true" class="px-2">
        <span>Asetukset</span>

        <v-icon color="pink">mdi-cog</v-icon>
      </v-btn>

      <v-btn v-if="loggedIn"  @click="uploadImagesDialog = true" class="px-2">
        <span>Lisää kuvia</span>

        <v-icon color="pink">mdi-image</v-icon>
      </v-btn>

      <v-btn @click="logout()" class="pl-2 pr-2">
        <span>Poistu</span>

        <v-icon color="pink">mdi-logout</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </v-app>
</template>

<script>
import Vue from 'vue';
import showdown from 'showdown';
import { mapState, mapActions } from 'vuex';
import VueSimplemde from 'vue-simplemde';

export default {
  name: 'App',

  components: {
    'upload-image': () => import('./components/UploadImage'),
    VueSimplemde,
  },

  metaInfo() {
    if (this.$route && this.$route.query && this.$route.query.blog && this.news.length) {
      const { title, image } = this.news[this.newsItemIndex];
      return {
        title: process.env.VUE_APP_TITLE,
        titleTemplate: `%s - ${title}`,
        meta: [{
          name: 'description',
          content: title,
        },
        { property: 'og:title', content: title },
        { property: 'og:type', content: 'article' },
        { property: 'og:description', content: title },
        { property: 'og:image', content: image },
        { property: 'twitter:image:src', content: image },
        { property: 'og:image:width', content: '1000' },
        { property: 'og:site_name', content: process.env.VUE_APP_TITLE },
        ],
        htmlAttrs: {
          lang: 'fi',
        },
      };
    }
    return {
      title: process.env.VUE_APP_TITLE,
      titleTemplate: `%s${this.page ? ` - ${this.page}` : ''}`,
      meta: [{
        name: 'description',
        content: this.hero.metaDescription || this.page,
      }],
      htmlAttrs: {
        lang: 'fi',
      },
    };
  },

  filters: {
    capitalize(value) {
      if (!value) return '';
      return value.toString().toUpperCase();
    },
  },

  data: () => ({
    blogEdit: false,
    editedBlog: {},
    configs: {
      spellChecker: false,
      hideIcons: ['guide', 'fullscreen', 'preview', 'side-by-side', 'image'],
      status: false,
    },
    editing: {
      esittely: false,
      yhteystiedot: false,
      hero: false,
      vaaliteemat: false,
      hide: false,
    },
    widthItems: ['Palsta', 'Koko leveys'],
    sideBar: false,
    itemEdit: false,
    currentEditedItem: {},
    currentEditedItemIndex: null,
    deleteNews: false,
    selectBlogImageModal: false,
    currentGalleryItem: {},
    newsItemIndex: 0,
    blogMetaDescription: null,
    blogMetaImage: null,
    newsItem: '',
    newsItemTitle: '',
    newsItemDate: new Date().toLocaleDateString('fi'),
    bottomNavi: false,
    drawer: false,
    converter: new showdown.Converter(),
    tab: 0,
    edit: true,
    loginDialog: false,
    galleryDialog: false,
    uploadImagesDialog: false,
    saveDialog: false,
    newPageDialog: false,
    newPageTitle: '',
    showGallerySelection: false,
    showHeroSelection: false,
    mobileHeroSelection: false,
    removeDialog: false,
    settingsDialog: false,
    selectableImages: null,
    currentGallery: null,
    offset: 10,
    pageTitle: '',
    carouselItem: 0,
    newBlogEntry: false,
  }),
  computed: {
    ...mapState({
      color: (state) => state.content.color,
      esittely: (state) => state.content.esittely,
      yhteystiedot: (state) => state.content.yhteystiedot,
      vaaliteemat: (state) => state.content.vaaliteemat,
      hide: (state) => state.content.hide,
      items: (state) => state.content.content.items,
      gallery: (state) => state.content.content.gallery,
      title: (state) => state.content.title,
      news: (state) => state.content.news,
      hero: (state) => state.content.hero,
      loggedIn: (state) => Object.keys(state.content.allowed).includes(state.user.userProfile.uid),
      showLogout: (state) => state.user.loggedIn,
    }),
    metaDescription() {
      return this.metaDescription;
    },
    cssVars() {
      return {
        '--primary-vxp-color': this.color.primary.hex,
        '--secondary-vxp-color': this.color.secondary.hex,
        '--tertiary-vxp-color': this.color.tertiary.hex,
      };
    },
    siteTitle() {
      return process.env.VUE_APP_TITLE;
    },
    mobile() {
      return !this.$vuetify.breakpoint.mdAndUp;
    },
    mobileHero() {
      return !this.$vuetify.breakpoint.mdAndUp;
    },
    mobileHeroImage() {
      return this.$vuetify.breakpoint.xs;
    },
    page() {
      return this.$route.params.page;
    },
    showingNews() {
      if (this.news && this.news.length) {
        return this.news.slice(0, this.offset);
      }
      return [];
    },
  },
  methods: {
    ...mapActions('user', {
      login: 'login',
      logout: 'logout',
    }),
    ...mapActions('content', {
      read: 'read',
      save: 'save',
      listImages: 'listImages',
      setItems: 'setItems',
    }),
    selectBlogItem(idx) {
      this.newsItemIndex = idx;
      const link = this.news[this.newsItemIndex].title;
      this.$router.push(`?blog=${encodeURI(link)}`);
      this.goTo('#blogi');
    },
    goTo(page) {
      if (page === '#vaaliteemat') {
        this.$router.push('/vaaliteemat');
        setTimeout(() => {
          this.$vuetify.goTo(page);
        }, 1000);
      } else if (this.page === 'vaaliteemat') {
        this.$router.push('/');
        setTimeout(() => {
          this.$vuetify.goTo(page);
        }, 1000);
      } else {
        this.$vuetify.goTo(page);
      }
    },
    toggleSideBar() {
      this.sideBar = true;
    },
    addCircle(item) {
      if (this.hero.circles) {
        this.hero.circles.push(item);
      } else {
        Vue.set(this.hero, 'circles', []);
        this.hero.circles.push(item);
      }
    },
    editItem(item) {
      this.currentEditedItemIndex = this.items[this.tab].content.indexOf(item);
      this.currentEditedItem = { ...item };
      if (item && !item.width) {
        [this.currentEditedItem.width] = this.widthItems;
      }
      this.itemEdit = true;
    },
    editBlog(item, newEntry = false) {
      this.newBlogEntry = newEntry;
      this.editedBlog = { ...item };
      this.blogEdit = true;
    },
    cancelBlogEdit() {
      this.editedBlog = {};
      this.blogEdit = false;
    },
    updateBlog() {
      if (this.newBlogEntry) {
        this.news.unshift({ ...this.editedBlog });
      } else {
        this.news[this.newsItemIndex] = { ...this.editedBlog };
      }
      this.editedBlog = {};
      this.blogEdit = false;
      this.confirmation();
    },
    updateItem() {
      this.items[this.tab].content[this.currentEditedItemIndex] = this.currentEditedItem;
      this.itemEdit = false;
      this.confirmation();
    },
    showGalleryDialog(img, item) {
      this.carouselItem = item.gallery.indexOf(img);
      this.currentGalleryItem = item;
      this.galleryDialog = true;
    },
    addToGallery(item, img) {
      if (!item.gallery) {
        Vue.set(item, 'gallery', []);
      }
      if (!item.gallery.some((i) => i.image === img)) {
        const image = { image: img, caption: '' };
        item.gallery.push(image);
      } else {
        const itemId = item.gallery.indexOf(img);
        item.gallery.splice(itemId, 1);
      }
    },
    openLogin() {
      this.login();
      this.loginDialog = false;
      // this.tab = 0;
      this.$router.push('/');
    },
    async selectBlogImage() {
      this.selectBlogImageModal = true;
      this.selectableImages = await this.listImages();
    },
    async gallerySelection(item) {
      this.showGallerySelection = true;
      this.currentGallery = item.gallery || [];
      this.currentGalleryItem = item;
      this.selectableImages = await this.listImages();
    },
    async showHeroSelectionDialog() {
      this.showHeroSelection = true;
      this.selectableImages = await this.listImages();
    },
    c(text) {
      return this.converter.makeHtml(text);
    },
    strip(text) {
      return text.replaceAll('# ', '').replaceAll('*', '').replaceAll('> ', '');
    },
    confirmation() {
      this.saveDialog = true;
    },
    addNews() {
      this.news.push({
        date: this.newsItemDate,
        description: this.newsItem,
        title: this.newsItemTitle,
      });
      this.newsItem = '';
      this.newsItemDate = new Date().toLocaleDateString('fi');
      this.newsItemTitle = '';
    },
    deleteNewsItem() {
      this.news.splice(this.newsItemIndex, 1);
      this.deleteNews = false;
      this.confirmation();
    },
    deleteCircle(idx) {
      this.hero.circles.splice(idx);
    },
    newPage() {
      this.items.push({
        columns: false,
        edit: false,
        content: [],
        gallery: [],
        pageTitle: this.newPageTitle,
        showGallery: false,
        showNews: false,
        tab: this.newPageTitle,
      });
      this.newPageDialog = false;
    },
    addSection() {
      this.items[this.tab].content.push({
        edit: true,
        md: '',
        embed: '',
        linkText: '',
        linkAddress: '',
      });
      const itemIndex = this.items[this.tab].content.length - 1;
      this.editItem(this.items[this.tab].content[itemIndex]);
    },
    showRemoveDialog(item) {
      this.itemToBeRemoved = item;
      this.removeDialog = true;
    },
    removeSection(item) {
      const itemId = this.items[this.tab].content.indexOf(item);
      this.items[this.tab].content.splice(itemId, 1);
      this.removeDialog = false;
    },
    removeNewsItem(item) {
      const index = this.news.indexOf(item);
      this.news.splice(index, 1);
    },
    moveBlogUp(item) {
      const itemIndex = this.news.indexOf(item);
      if (itemIndex < (this.news.length - 1)) {
        this.move(this.news, itemIndex, (itemIndex + 1), true);
        this.newsItemIndex += 1;
      }
    },
    moveBlogDown(item) {
      const itemIndex = this.news.indexOf(item);
      if (itemIndex > 0) {
        this.move(this.news, itemIndex, (itemIndex - 1), true);
        this.newsItemIndex -= 1;
      }
    },
    moveUp(item) {
      const itemIndex = this.items[this.tab].content.indexOf(item);
      if (itemIndex < (this.items[this.tab].content.length - 1)) {
        this.move(this.items[this.tab].content, itemIndex, (itemIndex + 1), true);
      }
    },
    moveDown(item) {
      const itemIndex = this.items[this.tab].content.indexOf(item);
      if (itemIndex > 0) {
        this.move(this.items[this.tab].content, itemIndex, (itemIndex - 1), true);
      }
    },
    moveNext() {
      const itemId = this.tab;
      if (this.tab < (this.items.length - 1)) {
        this.move(this.items, itemId, (itemId + 1));
        this.tab += 1;
      }
    },
    movePrevious() {
      const itemId = this.tab;
      if (this.tab > 0) {
        this.move(this.items, itemId, (itemId - 1));
        this.tab -= 1;
      }
    },
    move(arr, old, newI, dontSetItems = false) {
      let oldIndex = old;
      let newIndex = newI;
      while (oldIndex < 0) {
        oldIndex += arr.length;
      }
      while (newIndex < 0) {
        newIndex += arr.length;
      }
      if (newIndex >= arr.length) {
        let k = newIndex - arr.length;
        // eslint-disable-next-line no-plusplus
        while ((k--) + 1) {
          arr.push(undefined);
        }
      }
      arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
      if (!dontSetItems) {
        this.setItems(arr);
      }
    },
  },
  watch: {
    news: {
      handler() {
        if (this.$route && this.$route.query && this.$route.query.blog) {
          const newsItemName = decodeURI(this.$route.query.blog);
          this.newsItemIndex = this.news.findIndex((x) => x.title === newsItemName);
          setTimeout(() => {
            this.$vuetify.goTo('#blogi');
          }, 500);
        }
        // if (this.$route.path !== `/${this.items[val].tab}`) {
        //   this.$router.push(`/${this.items[val].tab}`);
        // }
        // this.items[val].pageTitle = this.items[val].tab;
      },
    },
  },
  async created() {
    if (this.$route.params.page === 'login') {
      this.loginDialog = true;
    }
    await this.read();
    // if (!this.mobile && this.$refs.tab0) {
    //   const initial = this.$refs.tab0[0].$el.offsetWidth;
    //   const interval = setInterval(() => {
    //     if (this.$refs.tab0[0]) {
    //       if (this.$refs.tab0[0].$el.offsetWidth !== initial) {
    //         clearInterval(interval);
    //         this.$refs.tabs.callSlider();
    //       }
    //     }
    //   }, 250);
    // }
    if (!this.color) {
      this.color.primary = '#C5B358';
    }
    // const currentItem = this.items.find((i) => i.tab === this.page);
    // if (currentItem) {
    //   this.tab = this.items.indexOf(currentItem);
    // }
    // this.items[this.tab].pageTitle = this.items[this.tab].tab;
  },
  mounted() {
  },
};
</script>
<style lang="scss">
  .circle-edit .v-text-field input {
    text-align: center;
  }

  .sheet-background {
    background-color: var(--tertiary-vxp-color) !important;
    position: relative;
  }

  .number-circle {
    background: var(--primary-vxp-color);
    border-radius: 50%;
    height: 200px;
    width: 200px;
    display: flex;
    position: relative;
    z-index: 1;
    justify-content: center;
    align-items: center;
    margin: 2px;
  }

  .number-circle p {
    font-size: 84px;
    color: #FFF;
    line-height:24px;
    text-align: center;
  }

  .container {
    max-width: 1100px !important;
  }

  .v-sheet.v-card {
    border-radius: 16px !important;
  }

  .vxp-banner-container {
    max-width: 1800px !important;
    width: 100%;
    margin-right: auto;
    margin-left: auto;
  }

  .v-btn {
    font-family: 'Inter', sans-serif;
    font-weight: 600 !important;
  }

  .site-content-actions .v-btn .v-btn__content, .vxp-hero-text-block .v-btn .v-btn__content {
    font-size: 14px;
    font-weight: 600;
  }

  .floater .v-btn__content {
    font-size: 12px;
    font-weight: 600;
  }

  .v-tabs-slider-wrapper {
    height: 4px !important;
  }

  .v-tabs-slider {
    border-radius: 2px;
  }

  .active-list-item {
    background: rgba(0, 0, 0, 0.06);
    border-left: 6px var(--primary-vxp-color) solid;
    border-radius: 0 !important;
  }

  .v-application {
    font-family: 'Montserrat', sans-serif !important;
  }

  .vxp-news-title {
    font-weight: 400 !important;
    font-family: 'Montserrat', sans-serif;
    color: rgba(0, 0, 0, 0.7);
  }

  .v-tab {
    font-weight: 400 !important;
    font-family: 'Montserrat', sans-serif;
    text-transform: none !important;
    font-size: 0.8rem !important;
  }

  h1.vxp-title {
    font-weight: 400 !important;
    font-family: 'Montserrat', sans-serif;
    font-size: 18px !important;
    align-self: center;
  }

  h1.vxp-title.vxp-mobile-title {
    font-size: 13px !important;
  }

  .vxp-primary {
    color: var(--primary-vxp-color) !important;
  }

  .top-left-title {
    font-weight: 600 !important;
    font-family: 'Inter', sans-serif;
    font-size: 20px;
    margin-left: 20px;
  }

  .top-right-title {
    font-weight: 600 !important;
    font-family: 'Inter', sans-serif;
    font-size: 20px;
    margin-right: 18px;
    margin-top: 8px;
  }

  .vxp-hero-text {
    font-weight: 600 !important;
    font-family: 'Inter', sans-serif;
    font-size: 80px !important;
    line-height: 85px;
    margin-bottom: 0 !important;
  }

  .vxp-content h1 {
    font-size: 48px !important;
    line-height: 48px;
    margin-bottom: 24px;
  }

  .vxp-content h2 {
    font-size: 38px !important;
    line-height: 38px;
  }

  .vxp-content h3 {
    font-size: 28px !important;
    line-height: 28px;
  }

  .vxp-content p {
    font-weight: 400 !important;
    font-family: "Inter", sans-serif;
    color: rgba(0,0,0,0.83);
    font-size: 18px;
    margin-bottom: 20px !important;
  }

  .vxp-content .blog-content p {
    font-size: 15px;
  }

  h2.vxp-title {
    font-weight: 600 !important;
    font-family: 'Inter', sans-serif;
    font-size: 56px !important;
  }

  h1, h2, h3, h4 {
    font-weight: 200 !important;
    font-family: "Inter", sans-serif !important;
    color: var(--primary-vxp-color) !important;
  }

  .blog-list {
    border-left: 1px #eee solid;
  }

  .flag {
    position:absolute !important;
    height: 100vh !important;
    width:100% !important;
    opacity:0.45;
  }

  @media screen and (max-width: 960px) {
    .flag {
      height: 50vh !important;
    }
    .vxp-content h1 {
      font-size: 38px !important;
      line-height: 38px;
      margin-bottom: 24px;
    }
    .blog-list {
      border-left: none;
      border-top: 1px #eee solid;
    }
    .puolue-position {
      position:absolute !important;
      bottom: 80px !important;
      right:120px !important;
      max-width: 120px !important;
      z-index: 12 !important;
    }
    .mobile-image-position {
      position:absolute !important;
      right: 0 !important;
      z-index: 0 !important;
      max-width:480px !important;
      margin-right: -100px !important;
      margin-top: -20px;
    }

    .number-circle-parent {
      height: 340px;
    }

    .vxp-hero-text {
      font-size: 42px !important;
      line-height: 45px;
      margin-top: 0px;
      margin-bottom:10px !important;
      text-align: right;
    }

    .number-circle {
      height: 180px;
      width: 180px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .number-circle p {
      font-size: 52px;
      line-height:24px;
    }

    .vxp-hero-subtitle {
      font-size: 18px !important;
    }
  }

  @media screen and (max-width: 480px) {
    .puolue-position {
      position:absolute !important;
      bottom: 45px !important;
      right:150px !important;
      max-width: 90px !important;
      z-index: 12 !important;
    }
    .number-circle {
      height: 130px;
      width: 130px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .number-circle p {
      font-size: 44px;
      line-height:24px;
    }

    .kotro-image {
      margin-top: -30px;
    }
    .mobile-image-position {
      max-width:400px !important;
      margin-right: -110px !important;
      top: 0;
      margin-top: -20px;
    }

    .vxp-hero-text {
      font-size: 22px !important;
      line-height: 35px;
      text-align: left;
    }

    .number-circle-parent {
      height: 280px;
    }

    .vxp-hero-subtitle {
      font-size: 20px !important;
    }

  }

  // h1::before {
  //   display: block;
  //   content: "";
  //   border: 3px solid rgba(55, 150, 255);
  //   height: 60px;
  //   width: 0;
  //   position: absolute;
  //   margin-left: -26px;
  //   margin-top: 10px;
  //   border-radius: 4px;
  //   transform: translateY(-1rem);
  // }

  .vxp-hero-subtitle {
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    font-size: 24px;
  }

  .vxp-hero-subtitle p {
    margin-bottom: 0 !important;
  }

  .mobile-hero-parent .vxp-hero-text.vxp-mobile-hero::before {
    height: 60px !important;
  }

  .vxp-news {
    font-weight: 400 !important;
    font-family: 'Montserrat', sans-serif;
    font-size: 30px !important;
    line-height: 30px;
    color: rgba(0, 0, 0, 0.6);
    padding-bottom: 12px;
    padding-top: 6px;
    text-align: left;
    display: flex;
    align-items: center;
    padding-left: 24px;
  }

  .vxp-news::before {
    width: 5px;
    display: inline-block;
    height: 40px;
    margin-left: -28px;
    margin-right: 25px;
    content: '';
    background: var(--primary-vxp-color);
    border-radius: 2.5px;
  }

  .vxp-top-menu {
    // align-self: flex-end;
    flex: none !important;
    width: auto !important;

    .v-item-group {
      background-color: transparent !important;
    }
  }

  .vxp-full-height {
    height: 100%;
  }

  .vxp-menu-align {
    align-self: center;
  }

  .site-content h1 {
    display: flex;
    align-items: center;
    padding-left: 24px;
    // border-left: 4px var(--primary-vxp-color) solid !important;
    margin-left: -28px;
  }

  .site-content h1::before {
    width: 5px;
    display: inline-block;
    height: 40px;
    margin-left: -28px;
    margin-right: 25px;
    content: '';
    background: var(--primary-vxp-color);
    border-radius: 2.5px;
  }

  .site-content p {
    margin-bottom: 0 !important;
    font-size: 15px;
    // line-height: 1.5em;
  }

  .mobile-hero-image {
    padding-left: 24px;
    padding-right: 24px;
  }

  .vxp-hero-text-block {
    margin-left: 40px;
    margin-right: 40px;
  }

  .mobile-hero-parent {
    .vxp-hero-text-block {
      margin-left: 16px;
      margin-right: 16px;
    }
    .vxp-mobile-hero {
      font-size: 23px !important;
      line-height: 28px;
    }

    .mobile-hero-image {
      width: 208px;
      padding-left: 0px;
      padding-right: 0px;
    }

  }

  .blog-list-title {
    text-overflow: clip !important;
    white-space: normal !important;
  }
</style>
<style>
  @import '~simplemde/dist/simplemde.min.css';
</style>
